import { alpha, Box, Typography, useTheme } from "@mui/material";
import { Clock, Link2, Plus } from "lucide-react";
import type { FC } from "react";
import { PinContractChoiceRow } from "web_myplann/Goals/Components/PinContract/PinContractChoiceRow";
import { GoalPortfolioTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";
import { SUCCESS_MYPLANN_LIGHT } from "web_myplann/Utils/constants";

const PageResources = Resources.Goals.Detail.Solution.Pin;

type Props = {
	open: boolean;
	portfolioType: GoalPortfolioTypeEnum;
	onClose: () => void;
	onPickExisting: () => void;
	onPickNew: () => void;
	onPickFuture: () => void;
};

export const PinContractChoiceDrawer: FC<Props> = ({
	open,
	portfolioType,
	onClose,
	onPickExisting,
	onPickNew,
	onPickFuture,
}) => {
	const { palette, spacingTokens } = useTheme();
	const { t } = useResource();

	const isSetAside = portfolioType === GoalPortfolioTypeEnum.SetAside;

	return (
		<MyPlannDrawer
			anchor="bottom"
			open={open}
			onClose={onClose}
			title={t(PageResources.chooseTitle)}
			closeButton
		>
			<Box pb={spacingTokens.lg}>
				<Typography
					variant="caption"
					display="block"
					color={palette.grey[500]}
					px={spacingTokens.lg}
					pb={spacingTokens.md}
				>
					{t(
						isSetAside
							? PageResources.chooseDescriptionSetAside
							: PageResources.chooseDescription,
					)}
				</Typography>
				<PinContractChoiceRow
					onClick={onPickExisting}
					iconBg={palette.myPLANN.main10}
					iconColor={palette.myPLANN.main}
					Icon={Link2}
					title={t(PageResources.existingTitle)}
					subtitle={t(PageResources.existingDescription)}
					hasDivider
				/>
				<PinContractChoiceRow
					onClick={isSetAside ? onPickNew : onPickFuture}
					iconBg={alpha(SUCCESS_MYPLANN_LIGHT, 0.2)}
					iconColor={SUCCESS_MYPLANN_LIGHT}
					Icon={isSetAside ? Plus : Clock}
					title={t(
						isSetAside ? PageResources.newTitle : PageResources.futureTitle,
					)}
					subtitle={t(
						isSetAside
							? PageResources.newDescription
							: PageResources.futureDescription,
					)}
				/>
			</Box>
		</MyPlannDrawer>
	);
};
